import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import AxiosClient from "../../assets/AxiosClient";


export default function AccountSetting () {
    const { user, setToken, SetNotification } = useStateContext();
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false);
    const oldpassRef = useRef();
    const newpassRef = useRef();
    const renewpassRef = useRef();
    const changePassword = async (event) => {
      event.preventDefault();
      if (newpassRef.current.value !== renewpassRef.current.value) {
        SetNotification("New password and confirmation do not match.", "danger");
        return;
      }

      setIsLoading(true);
      try {
        const response = await AxiosClient.post("Users/updatePassword", {
          oldpass: oldpassRef.current.value,
          newpass: newpassRef.current.value,
          id: user.id,
        });
        if (response.data?.token) setToken(response.data.token);
        SetNotification("Your password has been updated successfully.", "success");
        navigate("/Account/View");
      } catch (error) {
        SetNotification(error.response?.data?.message || "Unable to update your password.", "danger");
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
       
                <div className="col-12 col-xl-4">
              <div className="card card-plain h-100">
                <div className="card-header pb-0 p-3">
                  <div className="row">
                    <div className="col-md-8 d-flex align-items-center">
                      <h6 className="mb-0">Profile Information</h6>
                    </div>
                    <div className="col-md-4 text-end">
                     
                    </div>
                  </div>
                </div>
                <form className="card-body p-3" onSubmit={changePassword}>
                  <p className="text-sm text-secondary">Choose a new password to keep your account secure.</p>
                  <hr className="horizontal gray-light my-4"/>
                  <ul className="list-group">
                    <li className="list-group-item border-0 ps-0 pt-0"><label className="form-label" htmlFor="account-current-password">Current password</label>
                    <div className="input-group input-group-outline mb-3">
          <input id="account-current-password" type="password" autoComplete="current-password" className="form-control" placeholder="Current password" ref={oldpassRef} required/>
          </div>
                    </li>
                    <li className="list-group-item border-0 ps-0 pt-0">
                      <label className="form-label" htmlFor="account-new-password">New password</label>
                      <div className="input-group input-group-outline mb-3">
          <input id="account-new-password" type="password" autoComplete="new-password" className="form-control" placeholder="New password" ref={newpassRef} required
          />
          </div>
                      
                       </li>
                    <li className="list-group-item border-0 ps-0 pt-0">
                      <label className="form-label" htmlFor="account-confirm-password">Confirm new password</label>
                      <div className="input-group input-group-outline mb-3">
          <input id="account-confirm-password" type="password" autoComplete="new-password" className="form-control" placeholder="Confirm new password" ref={renewpassRef} required
          />
          </div>
                       
                        </li>

                    <li className="list-group-item border-0 ps-0 pb-0 d-flex justify-content-end gap-2">
                    <Link to="/Account/View" className="btn btn-outline-secondary mb-0">
                        Cancel
                      </Link>
                      <button type="submit" className="btn bg-gradient-info mb-0" disabled={loading}>
                        {loading ? "Saving..." : "Update password"}
                      </button>
                     
                    </li>
                  </ul>
                </form>
              </div>
            </div>
      
    )
}